module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-Student-79b9e0901f3c634956eea1990c2324c6.svg";